import React from 'react';
import { BaseDesignRegistrationPanelProps, DesignRegistrationPanel } from 'common/components';
import {
  FLOOR_SCREED_PANEL_ACTION_BLOCK,
  FLOOR_SCREED_PANEL_STRUCTURE,
} from './floor-screed-design-panel-constants';

export const FloorScreedDesignPanel: React.FC<BaseDesignRegistrationPanelProps> = ({
  isConsultationFormVisible,
  onConsultationSignupBtnClick,
}) => (
  <DesignRegistrationPanel
    isConsultationFormVisible={isConsultationFormVisible}
    structure={{
      panel: {
        ...FLOOR_SCREED_PANEL_STRUCTURE.panel,
        actionBlock: [
          {
            ...FLOOR_SCREED_PANEL_ACTION_BLOCK,
            onClick: onConsultationSignupBtnClick,
          },
        ],
      },
      mobilePanel: {
        ...FLOOR_SCREED_PANEL_STRUCTURE.mobilePanel,
        mobileButton: {
          ...FLOOR_SCREED_PANEL_STRUCTURE.mobilePanel.mobileButton,
          onClick: onConsultationSignupBtnClick,
        },
      },
    }}
  />
);
